/**
 * PageLoading — the canonical loading indicator for the feature pages.
 *
 * A centred spinner + caption so no page shows a blank flash while its
 * data is in flight. Same spin animation and muted styling everywhere.
 */
import { RefreshCw } from 'lucide-react'
import { clsx } from 'clsx'

export default function PageLoading({
  label = 'Loading…',
  className,
}: {
  label?: string
  className?: string
}) {
  return (
    <div
      className={clsx('flex items-center justify-center h-40', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <RefreshCw size={20} className="animate-spin text-text-muted" />
      <span className="ml-3 text-text-muted text-sm">{label}</span>
    </div>
  )
}
